import APIClient from './index';
import _ from 'lodash';

export const getPublicStats = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('Public/stats')
      .then(response => resolve(response.data))
      .catch(error => reject(_.get(error, 'data.error')));
  });
};
